export class InvoiceCashReceiptRetentionImportModel {
  counter: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  isChargeAccount: boolean = false;
  consecutiveCashReceipt: number = 0;
  bussinessDocumentsClassId: number = 0;
  bussinessDocumentsTypeCode: number | null = 0;
  documentConsecutive: number = 0;
  taxType: string = "";
  taxCode: string = "";
  baseValue: number = 0;
  rateValue: number = 0;
  constructor(
    counter: number,
    companyId: number,
    branchId: number,
    enterpriseId: number,
    isChargeAccount: boolean,
    consecutiveCashReceipt: number,
    bussinessDocumentsClassId: number,
    bussinessDocumentsTypeCode: number | null,
    documentConsecutive: number,
    taxType: string,
    taxCode: string,
    baseValue: number,
    rateValue: number
  ) {
    this.counter = counter;
    this.companyId = companyId;
    this.branchId = branchId;
    this.enterpriseId = enterpriseId;
    this.isChargeAccount = isChargeAccount;
    this.consecutiveCashReceipt = consecutiveCashReceipt;
    this.bussinessDocumentsClassId = bussinessDocumentsClassId;
    this.bussinessDocumentsTypeCode = bussinessDocumentsTypeCode;
    this.documentConsecutive = documentConsecutive;
    this.taxType = taxType;
    this.taxCode = taxCode;
    this.baseValue = baseValue;
    this.rateValue = rateValue;
  }
}